import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; // <-- ✅ Importar useNavigate
import { PedidosService } from '../services/pedidosService';
import { ChoferesService } from '../services/choferesService';
import TablaPedidos from './TablaPedidos';
import GestionPedidos from './GestionPedidos';
import FormularioCombustible from './FormularioCombustible';
import { AutosService } from '../services/autosService';
import { CombustibleService } from '../services/combustibleService';
import './DashboardEmpleado.css';
import MapaRutas from './MapaRutas';
import FormularioAutos from './FormularioAutos';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBell,
  faUser,
  faSignOutAlt,
  faHome,
  faClipboardList,
  faTruck,
  faUsers,
  faChartBar,
  faMapMarkedAlt,
  faDatabase
} from '@fortawesome/free-solid-svg-icons';
import { migratePedidosToFirestore, checkFirestoreData } from '../utils/migrateData';
import { testChoferRegistration, limpiarDatosPrueba } from '../utils/testChoferes';
import { testPedidoCreation, limpiarDatosPedidos, verificarEstadoPedidos } from '../utils/testPedidos';

const DashboardEmpleado = () => {
  const [pedidos, setPedidos] = useState([]);
  const [autos, setAutos] = useState([]);
  const [choferes, setChoferes] = useState([]);
  // Ya no se permite crear pedidos desde el dashboard del empleado de logística
  const [mostrarMapa, setMostrarMapa] = useState(false);
  const [mostrarFormularioCombustible, setMostrarFormularioCombustible] = useState(false);
  const [vistaActual, setVistaActual] = useState('dashboard');
  const [migracionEnProgreso, setMigracionEnProgreso] = useState(false);
  const [filtros, setFiltros] = useState({
    estado: 'todos',
    fecha: '',
    cliente: '',
    chofer: ''
  });
  const [pedidoSeleccionado, setPedidoSeleccionado] = useState(null);
  const [formEntrega, setFormEntrega] = useState({
    fechaRecibido: '',
    fechaEntregaReal: '',
    direccionEntrega: '',
    choferAsignado: '',
    estadoEntrega: 'en_preparacion'
  });

  const navigate = useNavigate(); // <-- ✅ Hook para navegar
  const usuario = (() => { try { return JSON.parse(localStorage.getItem('usuario')); } catch { return null; } })();
  const nombreEmpleado = usuario?.nombre || usuario?.displayName || usuario?.usuario || '';

  useEffect(() => {
    console.log('DashboardEmpleado: Iniciando carga de datos...');
    
    const unsubscribePedidos = PedidosService.suscribirsePedidos(setPedidos);
    const unsubscribeChoferes = ChoferesService.suscribirseChoferes((choferesData) => {
      console.log('DashboardEmpleado: Choferes recibidos:', choferesData);
      console.log('DashboardEmpleado: Cantidad de choferes:', choferesData?.length || 0);
      if (choferesData && choferesData.length > 0) {
        console.log('DashboardEmpleado: Primer chofer:', choferesData[0]);
      }
      setChoferes(choferesData || []);
    });
    const unsubscribeAutos = AutosService.suscribirseAutos(setAutos);

    return () => {
      console.log('DashboardEmpleado: Limpiando suscripciones...');
      unsubscribePedidos();
      unsubscribeChoferes();
      if (typeof unsubscribeAutos === 'function') unsubscribeAutos();
    };
  }, []);

  // Eliminado: creación de pedidos para empleado de logística

  const handleActualizarPedido = async (pedidoId, nuevosDatos) => {
    try {
      await PedidosService.actualizarPedido(pedidoId, nuevosDatos);
    } catch (error) {
      console.error('Error al actualizar pedido:', error);
    }
  };

  const handleCrearCombustible = async (datosCombustible) => {
    try {
      const consumo = {
        ...datosCombustible,
        // vincular por placas si coincide
      };
      await CombustibleService.registrarConsumo(consumo);
      alert('Consumo de combustible registrado exitosamente');
      setMostrarFormularioCombustible(false);
    } catch (error) {
      console.error('Error al registrar combustible:', error);
      alert('No se pudo registrar el consumo de combustible.');
    }
  };

  const handleMigrarDatos = async () => {
    if (migracionEnProgreso) return;
    
    setMigracionEnProgreso(true);
    try {
      console.log('Iniciando migración de datos...');
      const resultado = await migratePedidosToFirestore();
      
      if (resultado.success) {
        alert(`Migración exitosa: ${resultado.count} pedidos migrados a Firestore`);
        // Recargar la página para usar los nuevos datos
        window.location.reload();
      } else {
        alert(`Error en la migración: ${resultado.error}`);
      }
    } catch (error) {
      console.error('Error durante la migración:', error);
      alert('Error durante la migración de datos');
    } finally {
      setMigracionEnProgreso(false);
    }
  };

  const handleProbarChoferes = async () => {
    try {
      console.log('Iniciando prueba de choferes...');
      const resultado = await testChoferRegistration();
      
      if (resultado.success) {
        alert(`Prueba exitosa: Chofer creado con ID ${resultado.choferId}. Total choferes: ${resultado.totalChoferes}`);
        // Recargar la página para ver los cambios
        window.location.reload();
      } else {
        alert(`Error en la prueba: ${resultado.error}`);
      }
    } catch (error) {
      console.error('Error durante la prueba:', error);
      alert('Error durante la prueba de choferes');
    }
  };

  const handleLimpiarDatos = () => {
    if (window.confirm('¿Estás seguro de que quieres limpiar todos los datos de choferes?')) {
      limpiarDatosPrueba();
      alert('Datos limpiados. Recargando página...');
      window.location.reload();
    }
  };

  const handleProbarPedidos = async () => {
    try {
      console.log('Iniciando prueba de pedidos...');
      const resultado = await testPedidoCreation();
      
      if (resultado.success) {
        alert(`Prueba exitosa: Pedido creado con ID ${resultado.pedidoId}. Total pedidos: ${resultado.totalPedidos}`);
        // Recargar la página para ver los cambios
        window.location.reload();
      } else {
        alert(`Error en la prueba: ${resultado.error}`);
      }
    } catch (error) {
      console.error('Error durante la prueba:', error);
      alert('Error durante la prueba de pedidos');
    }
  };

  const handleVerificarPedidos = () => {
    const pedidos = verificarEstadoPedidos();
    alert(`Estado actual: ${pedidos.length} pedidos en localStorage`);
  };

  const handleLimpiarPedidos = () => {
    if (window.confirm('¿Estás seguro de que quieres limpiar todos los datos de pedidos?')) {
      limpiarDatosPedidos();
      alert('Datos de pedidos limpiados. Recargando página...');
      window.location.reload();
    }
  };

  const abrirModalPedido = (pedido) => {
    setPedidoSeleccionado(pedido);
    setFormEntrega({
      fechaRecibido: pedido.fechaCompra || '',
      fechaEntregaReal: pedido.fechaEntrega || '',
      direccionEntrega: pedido.direccion || '',
      choferAsignado: pedido.chofer || '',
      estadoEntrega: pedido.estatus || 'en_preparacion'
    });
  };

  const handleChangeEntrega = (e) => {
    const { name, value } = e.target;
    setFormEntrega(prev => ({ ...prev, [name]: value }));
  };

  const handleRegistrarEntrega = async (e) => {
    e.preventDefault();
    if (!pedidoSeleccionado) return;
    try {
      await PedidosService.actualizarPedido(pedidoSeleccionado.id, {
        fechaRecibido: formEntrega.fechaRecibido,
        fechaEntregaReal: formEntrega.fechaEntregaReal,
        direccion: formEntrega.direccionEntrega,
        chofer: formEntrega.choferAsignado,
        estatus: formEntrega.estadoEntrega
      });
      alert('Datos de entrega registrados');
      setPedidoSeleccionado(null);
    } catch (error) {
      console.error(error);
      alert('No se pudieron registrar los datos de entrega');
    }
  };

  const pedidosFiltrados = pedidos.filter(pedido => {
    if (filtros.estado !== 'todos' && pedido.estatus !== filtros.estado) return false;
    if (filtros.fecha && pedido.fechaCompra !== filtros.fecha) return false;
    if (filtros.cliente && !pedido.cliente.toLowerCase().includes(filtros.cliente.toLowerCase())) return false;
    if (filtros.chofer && pedido.chofer !== filtros.chofer) return false;
    return true;
  });

  const pedidosPendientesEmpleado = pedidos.filter(p => {
    const pendiente = p.estatus === 'en_preparacion' || p.estatus === 'ruta';
    const asignado = nombreEmpleado ? p.chofer === nombreEmpleado : true;
    return pendiente && asignado;
  }).map(p => ({ pedidoId: p.id, direccion: p.direccion || p.clienteDireccion || p.direccionEntrega || '' }));

  const estadisticas = {
    choferesActivos: choferes.filter(c => c.activo !== false).length,
    totalChoferes: choferes.length,
    clientesRegistrados: new Set(pedidos.map(p => p.cliente)).size,
    pedidosEntregados: pedidos.filter(p => p.estatus === 'entregado').length
  };

  return (
    <div className="dashboard-empleado">
      {/* Header */}
      <header className="header">
        <div className="logo">LOGISTICA</div>
        <div className="search-bar">
          <input type="text" placeholder="Buscar pedidos..." />
        </div>
        <div className="user-actions">
          <button 
            className="btn-primary" 
            onClick={() => setMostrarFormularioCombustible(true)}
            style={{ marginRight: '10px' }}
          >
            Registrar Combustible
          </button>
          <button 
            className="btn-secondary" 
            onClick={handleMigrarDatos}
            disabled={migracionEnProgreso}
            style={{ marginRight: '10px' }}
          >
            <FontAwesomeIcon icon={faDatabase} style={{ marginRight: '5px' }} />
            {migracionEnProgreso ? 'Migrando...' : 'Migrar Datos'}
          </button>
          <button 
            className="btn-secondary" 
            onClick={handleProbarChoferes}
            style={{ marginRight: '10px' }}
          >
            Probar Choferes
          </button>
          <button 
            className="btn-secondary" 
            onClick={handleLimpiarDatos}
            style={{ marginRight: '10px' }}
          >
            Limpiar Choferes
          </button>
          <button 
            className="btn-secondary" 
            onClick={handleProbarPedidos}
            style={{ marginRight: '10px' }}
          >
            Probar Pedidos
          </button>
          <button 
            className="btn-secondary" 
            onClick={handleVerificarPedidos}
            style={{ marginRight: '10px' }}
          >
            Verificar Pedidos
          </button>
          <button 
            className="btn-secondary" 
            onClick={handleLimpiarPedidos}
            style={{ marginRight: '10px' }}
          >
            Limpiar Pedidos
          </button>
          <FontAwesomeIcon icon={faBell} className="icon" />
          <FontAwesomeIcon icon={faUser} className="icon" />
          <button
            className="logout-btn"
            onClick={() => {
              localStorage.removeItem('usuario');
              localStorage.removeItem('tipoUsuario');
              window.location.href = '/';
            }}
          >
            <FontAwesomeIcon icon={faSignOutAlt} /> Logout
          </button>
        </div>
      </header>

      <div className="main-container">
        {/* Sidebar */}
        <aside className="sidebar">
          <nav className="nav-menu">
            <div
              className={`nav-item ${vistaActual === 'dashboard' ? 'active' : ''}`}
              onClick={() => setVistaActual('dashboard')}
            >
              <FontAwesomeIcon icon={faHome} className="nav-icon" />
              <span>Inicio</span>
            </div>
          <div
              className={`nav-item ${vistaActual === 'autos' ? 'active' : ''}`}
              onClick={() => setVistaActual('autos')}
            >
              <FontAwesomeIcon icon={faTruck} className="nav-icon" />
              <span>Autos</span>
            </div>
            <div className="nav-item" onClick={() => setMostrarFormularioCombustible(true)}>
              <FontAwesomeIcon icon={faClipboardList} className="nav-icon" />
              <span>Combustible</span>
            </div>
            <div
              className={`nav-item ${vistaActual === 'pedidos' ? 'active' : ''}`}
              onClick={() => setVistaActual('pedidos')}
            >
              <FontAwesomeIcon icon={faClipboardList} className="nav-icon" />
              <span>Pedidos</span>
            </div>

            {/* ✅ Repartidores - redirección a /choferes */}
            <div className="nav-item" onClick={() => navigate('/choferes')}>
              <FontAwesomeIcon icon={faTruck} className="nav-icon" />
              <span>Repartidores</span>
            </div>
          </nav>
        </aside>

        {/* Main Content */}
        <main className="main-content">
          {vistaActual === 'pedidos' ? (
            <GestionPedidos />
          ) : vistaActual === 'autos' ? (
            <FormularioAutos />
          ) : (
            <>
      {/* Panel Summary */}
      <section className="panel-summary">
        <h2>Resumen del Panel</h2>
        <div className="summary-cards">
                  <div className="summary-card">
                    <h3>Estado de Repartidores</h3>
                    <div className="card-content">
                      <div className="card-number">{estadisticas.choferesActivos}</div>
                      <div className="card-subtitle">de {estadisticas.totalChoferes} Totales</div>
                      <button
                        className="card-button"
                        onClick={() => navigate('/choferes')}
                      >
                        Ver Repartidores
                      </button>
                    </div>
                  </div>

                  <div className="summary-card">
                    <h3>Clientes Registrados</h3>
                    <div className="card-content">
                      <div className="card-number">{estadisticas.clientesRegistrados}</div>
                      <div className="card-subtitle">clientes únicos</div>
                      <button className="card-button">Registrar Nuevo Cliente</button>
                    </div>
                  </div>

                  <div className="summary-card">
                    <h3>Mapa (OSM/OSRM)</h3>
                    <div className="card-content">
                      <div style={{ width:'100%', marginBottom:8 }}>
                        <MapaRutas
                          pedidosPendientes={pedidosPendientesEmpleado}
                          origenTexto={process.env.REACT_APP_ALMACEN_DIRECCION || 'Guadalajara, Jalisco'}
                          modo="compacto"
                          autoCalcular={true}
                        />
                      </div>
                      <button className="card-button" onClick={() => setMostrarMapa(true)}>Ver Mapa Completo</button>
                    </div>
                  </div>

                  {/* Card de Reportes Exportables eliminada */}
                </div>
              </section>

              {/* Gestión de Pedidos (sin creación) */}
              <section className="gestion-pedidos">
                <div className="section-header">
                  <h2>Gestión de Pedidos</h2>
                  {/* Botón de registro removido para el rol empleado */}
                </div>

                {/* Filtros */}
                <div className="filtros-pedidos">
                  <div className="filter-group">
                    <label>Estado:</label>
                    <select
                      value={filtros.estado}
                      onChange={(e) => setFiltros({ ...filtros, estado: e.target.value })}
                    >
                      <option value="todos">Todos</option>
                      <option value="en_preparacion">En Preparación</option>
                      <option value="ruta">En Ruta</option>
                      <option value="entregado">Entregado</option>
                      <option value="cancelado">Cancelado</option>
                    </select>
                  </div>

                  <div className="filter-group">
                    <label>Fecha:</label>
                    <input
                      type="date"
                      value={filtros.fecha}
                      onChange={(e) => setFiltros({ ...filtros, fecha: e.target.value })}
                    />
                  </div>

                  <div className="filter-group">
                    <label>Cliente:</label>
                    <input
                      type="text"
                      placeholder="Nombre del cliente"
                      value={filtros.cliente}
                      onChange={(e) => setFiltros({ ...filtros, cliente: e.target.value })}
                    />
                  </div>

                  <div className="filter-group">
                    <label>Repartidor:</label>
                    <input
                      type="text"
                      placeholder="Nombre del repartidor"
                      value={filtros.chofer}
                      onChange={(e) => setFiltros({ ...filtros, chofer: e.target.value })}
                    />
                  </div>

                  <button className="btn-secondary">Aplicar Filtros</button>
                </div>

                {/* Tabla de Pedidos */}
                <TablaPedidos
                  pedidos={pedidosFiltrados}
                  choferes={choferes}
                  onActualizarPedido={handleActualizarPedido}
                  onVerDetalles={abrirModalPedido}
                  onEliminarPedido={async (pedido) => {
                    if (!window.confirm(`¿Eliminar el pedido ${pedido.numeroDocumento || pedido.id}?`)) return;
                    try {
                      await PedidosService.eliminarPedido(pedido.id);
                      alert('Pedido eliminado');
                    } catch (error) {
                      console.error(error);
                      alert('No se pudo eliminar el pedido');
                    }
                  }}
                />
              </section>
            </>
          )}
        </main>
      </div>

      {/* Modal de registro eliminado para empleado */}
      {pedidoSeleccionado && (
        <div className="modal-overlay" onClick={() => setPedidoSeleccionado(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Detalles del Pedido</h2>
              <button className="close-button" onClick={() => setPedidoSeleccionado(null)}>×</button>
            </div>
            <div className="modal-body">
              <div className="detalles-grid">
                <div className="detalle-item"><label>ID Pedido:</label><span>{pedidoSeleccionado.numeroDocumento || pedidoSeleccionado.id}</span></div>
                <div className="detalle-item"><label>Cliente:</label><span>{pedidoSeleccionado.cliente}</span></div>
                <div className="detalle-item"><label>Repartidor:</label><span>{pedidoSeleccionado.chofer}</span></div>
                <div className="detalle-item"><label>Estado:</label><span>{pedidoSeleccionado.estatus}</span></div>
                <div className="detalle-item full-width"><label>Dirección Completa:</label><span>{pedidoSeleccionado.direccionCompleta || pedidoSeleccionado.direccion || '-'}</span></div>
                {pedidoSeleccionado.referencias && (
                  <div className="detalle-item full-width"><label>Referencias:</label><span>{pedidoSeleccionado.referencias}</span></div>
                )}
              </div>
              <hr />
              <h3>Registrar Datos de Entrega</h3>
              <form className="form-entrega" onSubmit={handleRegistrarEntrega}>
                <div className="filtros-grid">
                  <div className="filter-group">
                    <label>Fecha de Recibido *</label>
                    <input type="date" name="fechaRecibido" value={formEntrega.fechaRecibido} onChange={handleChangeEntrega} required />
                  </div>
                  <div className="filter-group">
                    <label>Fecha Entrega Real</label>
                    <input type="date" name="fechaEntregaReal" value={formEntrega.fechaEntregaReal} onChange={handleChangeEntrega} />
                  </div>
                </div>
                <div className="filter-group">
                  <label>Dirección de Entrega *</label>
                  <input type="text" name="direccionEntrega" placeholder="Dirección completa de entrega" value={formEntrega.direccionEntrega} onChange={handleChangeEntrega} required />
                </div>
                <div className="filtros-grid">
                  <div className="filter-group">
                    <label>Chofer * ({choferes.length} disponibles)</label>
                    <select name="choferAsignado" value={formEntrega.choferAsignado} onChange={handleChangeEntrega} required>
                      <option value="">Seleccionar chofer...</option>
                      {choferes.length === 0 ? (
                        <option value="" disabled>Cargando choferes...</option>
                      ) : (
                        choferes.map(chofer => {
                          console.log('Renderizando chofer:', chofer);
                          return (
                            <option key={chofer.id} value={`${chofer.nombre} ${chofer.apellido}`}>
                              {chofer.nombre} {chofer.apellido}
                            </option>
                          );
                        })
                      )}
                    </select>
                    {/* Debug info */}
                    <div style={{fontSize: '12px', color: '#666', marginTop: '5px'}}>
                      Debug: {choferes.length} choferes cargados
                    </div>
                  </div>
                  <div className="filter-group">
                    <label>Estado de Entrega *</label>
                    <select name="estadoEntrega" value={formEntrega.estadoEntrega} onChange={handleChangeEntrega} required>
                      <option value="en_preparacion">En Preparación</option>
                      <option value="ruta">En Ruta</option>
                      <option value="entregado">Entregado</option>
                      <option value="cancelado">Cancelado</option>
                    </select>
                  </div>
                </div>
                <div className="acciones">
                  <button type="submit" className="btn-details">Registrar Datos de Entrega</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Modal Mapa Rutas para empleado */}
      {mostrarMapa && (
        <div className="modal-overlay" onClick={() => setMostrarMapa(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <MapaRutas
              pedidosPendientes={pedidosPendientesEmpleado}
              origenTexto={process.env.REACT_APP_ALMACEN_DIRECCION || 'Guadalajara, Jalisco'}
              autoCalcular={true}
              onClose={() => setMostrarMapa(false)}
            />
          </div>
        </div>
      )}

      {/* Modal Formulario de Combustible */}
      {mostrarFormularioCombustible && (
        <FormularioCombustible
          vehiculos={autos.map(a => ({ id: a.id, nombre: a.placas }))}
          onSubmit={handleCrearCombustible}
          onCancel={() => setMostrarFormularioCombustible(false)}
        />
      )}

      {/* Footer */}
      <footer className="footer">
        <div className="footer-left">
          <a href="#soporte">Soporte</a>
          <a href="#legal">Legal</a>
        </div>
        <div className="footer-center">
          <span>↑</span>
        </div>
      </footer>
    </div>
  );
};

export default DashboardEmpleado;